module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_vm._v("To the inspiring memory and kindness of Lloyd Alexander,")]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-last"
  }, [_vm._v("And to the students at Mindess Elementary School in Ashland, Massachusetts, for first leading me, on March 15, 2012, to")]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Emperor,")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Ostrich,")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded-last"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("and Ghoul,")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_vm._v("and to the thousands of children who’ve brainstormed with me in creative-writing workshops ever since. To answer the question you frequently ask me, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yes")]), _vm._v(". This really is how I write a story, and this one’s for you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0